import { Link } from "react-router-dom";

const navCards = [
  {
    to: "/about",
    icon: "ri-building-4-line",
    label: "About GH",
    title: "Our Story &amp; Expertise",
    desc: "Since 2012 — Korean trade, K-beauty sourcing and global export logistics in one practical service structure.",
  },
  {
    to: "/brands",
    icon: "ri-stack-line",
    label: "Brands",
    title: "125+ Korean Beauty Brands",
    desc: "Explore our portfolio of leading Korean beauty brands with mixed-order consolidation through one trusted export partner.",
  },
  {
    to: "/services",
    icon: "ri-ship-2-line",
    label: "Services",
    title: "Sourcing to Shipping",
    desc: "Multi-brand sourcing, wholesale quotation, inspection, export packing, documentation and flexible global logistics.",
  },
  {
    to: "/markets",
    icon: "ri-global-line",
    label: "Markets",
    title: "Global Export Reach",
    desc: "Supporting K-beauty buyers across North America, Latin America, Europe, the Middle East and Central Asia.",
  },
  {
    to: "/contact",
    icon: "ri-mail-send-line",
    label: "Contact",
    title: "Request a Quote",
    desc: "Share your target brands, products and destination. Our team responds with pricing, MOQ guidance and a shipping plan.",
  },
];

export default function NavigationHub() {
  return (
    <section className="w-full px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-px bg-accent-500" />
            <span className="font-label text-[11px] tracking-[0.22em] uppercase text-accent-700">
              Explore GH
            </span>
            <span className="w-8 h-px bg-accent-500" />
          </div>
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl lg:text-6xl leading-[1.05] font-light">
            Everything you need,
            <br />
            <span className="italic">one trusted partner.</span>
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-foreground-700 text-base md:text-lg leading-relaxed font-light">
            Navigate through our services, brands and export capabilities — each designed for serious global beauty buyers.
          </p>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {navCards.map((card) => (
            <Link
              key={card.to}
              to={card.to}
              className="group flex flex-col p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-background-50 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                  <i className={`${card.icon} text-xl`} />
                </div>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-accent-500 transition-colors text-lg" />
              </div>
              <span className="mt-5 font-label text-[10px] tracking-[0.2em] uppercase text-accent-700">
                {card.label}
              </span>
              <h3 className="mt-2 font-heading text-foreground-950 text-xl leading-tight">
                {card.title}
              </h3>
              <p className="mt-3 text-foreground-700 text-[14px] leading-relaxed font-light flex-1">
                {card.desc}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}